import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function UbiNoInsuranceBottomSheet() {
  const {t} = useInferableTranslation();
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T20108')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <ul className="bottom_sheet_list">
            <li className="bottom_sheet_item">{t('T20109')}</li>
            <li className="bottom_sheet_item">{t('T20110')}</li>
          </ul>

          <div className="ubi_signup_guide">
            <strong className="ubi_guide_title">{t('T20111')}</strong>
            <ul className="ubi_guide_list">
              <li className="ubi_guide_item">{t('T20112')}</li>
              <li className="ubi_guide_item">{t('T20113')}</li>
              <li className="ubi_guide_item">{t('T20114')}</li>
            </ul>
          </div>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T20115')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UbiNoInsuranceBottomSheet;
